import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectLibraryComponentDialogComponent } from '../select-library-component-dialog/select-library-component-dialog.component';
import { Vessel } from 'icreate/common/models/vessel';
import { LibraryService } from '@service/library.service';
import { lastValueFrom } from 'rxjs';
import { LibraryComponent } from 'icreate/common/models/library-component';
import { ElementConditionViewData } from 'icreate/common/models/element-condition';
import { elementConditionNameMaxLimit } from 'icreate/common/validators/element-condition/element-condition-validator';

@Component({
    selector: 'app-condition-item',
    templateUrl: './condition-item.component.html',
    styleUrls: ['./condition-item.component.css'],
    standalone: false,
})
export class ConditionItemComponent {
    readonly NAME_MAX_LEN = elementConditionNameMaxLimit;

    @Input() condition!: ElementConditionViewData;
    @Input() vessel: Vessel;

    isOpenOption: boolean = false;

    @ViewChild('titleInput') titleInput: ElementRef;
    @ViewChild('optionIcon', { read: ElementRef }) optionIcon: ElementRef;

    @Output() onSelectCondition = new EventEmitter<ElementConditionViewData>();
    @Output() onDeleteCondition = new EventEmitter<ElementConditionViewData>();
    @Output() onClearAllSetting = new EventEmitter<ElementConditionViewData>();
    @Output() onSetToAlarm = new EventEmitter<ElementConditionViewData>();
    @Output() onSelectComponent = new EventEmitter<{
        component: LibraryComponent;
        condition: ElementConditionViewData;
    }>();

    isFocusing: boolean = false;

    constructor(
        private dialog: MatDialog,
        private libraryService: LibraryService
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: MouseEvent) {
        if (this.isOpenOption && !this.optionIcon?.nativeElement?.contains(event.target)) {
            this.isOpenOption = false;
        }

        if (this.isFocusing && !this.titleInput?.nativeElement.contains(event.target)) {
            this.isFocusing = false;
        }
    }

    setToAlarm() {
        this.onSetToAlarm.emit(this.condition);
        this.isOpenOption = false;
    }

    deleteCondition() {
        this.onDeleteCondition.emit(this.condition);
        this.isOpenOption = false;
    }

    clearAllSetting() {
        this.onClearAllSetting.emit(this.condition);
        this.isOpenOption = false;
    }

    renameCondition() {
        if (this.titleInput?.nativeElement) {
            const len = this.titleInput.nativeElement.value?.length ?? 0;
            this.titleInput.nativeElement.focus();
            this.titleInput.nativeElement.setSelectionRange(len, len);
            this.isFocusing = true;
        }

        this.isOpenOption = false;
    }

    focusTitle() {
        if (this.titleInput?.nativeElement) {
            const len = this.titleInput.nativeElement.value?.length ?? 0;
            this.titleInput.nativeElement.focus();
            this.titleInput.nativeElement.setSelectionRange(len, len);
            this.isFocusing = true;
        }
    }

    openOption() {
        this.isOpenOption = !this.isOpenOption;
        if (this.isOpenOption) {
            this.onSelectCondition.emit(this.condition);
        } else {
            this.onSelectCondition.emit(undefined);
        }
    }

    async openSelectLibraryComponentDialog() {
        try {
            const libraryList = await this.libraryService.getByShipyardId(this.vessel.shipyardId);
            const dialogRef = this.dialog.open(SelectLibraryComponentDialogComponent, {
                data: {
                    libraryList,
                    selectedComponent: this.condition.component ? this.condition.component : undefined,
                },
                disableClose: true,
                autoFocus: false,
            });

            const libraryComponent = await lastValueFrom(dialogRef.afterClosed());

            if (libraryComponent) {
                this.onSelectComponent.emit({
                    component: libraryComponent,
                    condition: this.condition,
                });
            }
        } catch (error) {
            console.log(error);
        }
    }
}
